import { useContext } from 'react';

import { ProfessionalEditionCreditsContext } from './ProfessionalEditionCreditsProvider';

export const useProfessionalEditionCreditsContext = () => {
  const context = useContext(ProfessionalEditionCreditsContext);
  if (!context) {
    throw new Error('useCreditsContext must be used within a CreditsProvider');
  }
  return context;
};
